export const TERMS_ENTERPRISE_LINK = 'https://www.productscience.ai/terms#enterprise'
export const TERMS_SELF_SERVE_LINK = 'https://www.productscience.ai/terms#selfserve'
export const PRIVACY_LINK = 'https://www.productscience.ai/privacy'
export const PATH_ROOT = '/'
